import { ConnectionState } from 'middleware-types';

export enum ConnectionStateExtended {
	NotConnected = 'NotConnected',
	IncomingRequest = 'IncomingRequest',
}

export type ComprehensiveConnectionState = ConnectionState | ConnectionStateExtended;
